import { call, put, takeLatest } from 'redux-saga/effects';
import { dashboardService } from './dashboard.service';
import { GET_DASHBOARD, GET_DASHBOARD_SUCCESS } from './dashboard.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';

function* getDashboardSaga({ type }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(dashboardService.getDashboard);
    yield put({ type: GET_DASHBOARD_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchDashboard() {
  yield takeLatest(GET_DASHBOARD, getDashboardSaga);
}
